import { render, staticRenderFns } from "./piecingDetails.vue?vue&type=template&id=4a46880c&scoped=true"
import script from "./piecingDetails.vue?vue&type=script&lang=js"
export * from "./piecingDetails.vue?vue&type=script&lang=js"
import style0 from "./piecingDetails.vue?vue&type=style&index=0&id=4a46880c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46880c",
  null
  
)

export default component.exports